import moment from "moment";

export const columns = ({ handleClickExportPdf }) => [
  {
    Header: "Data Solicitação",
    align: "start",
    getValue: (row) => {
      return moment(row?.solicitacoesDasa?.dataCriacao).format("DD/MM/YYYY");
    },
  },
  {
    Header: "Exame",
    align: "start",
    getValue: (row) => {
      const exames = row?.solicitacoesDasa
        ?.map((item) => item.exameDasa?.codigo)

      return exames.map((exame) => exame).join(", ");
    },

  },
  {
    Header: "Profissional",
    align: "start",
    getValue: (row) => {
      return row?.profissionalSaude?.nome;
    },
  },
  {
    Header: "Paciente",
    align: "start",
    getValue: (row) => {
      return row?.sujeitoAtencao?.nome;
    },
  },
];
